/** Catalogue prices are stored in minor units. */
export function productPriceLabel(value: number | undefined, currency: string | undefined): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return '';
  }
  const code = (currency || 'GBP').toUpperCase();
  const amount = value / 100;
  try {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `£${amount.toFixed(2)}`;
  }
}
